import React, { Component } from "react";
import Auth from "../routes/Auth";

const LOGOUT_CHECK_INTERVAL = 1000; // 1 second
const LOGOUT_TIMEOUT = 600000; // 10 minutes
const STORE_KEY = "lastAction";

const EVENTS = [
  "mousemove",
  "keydown",
  "wheel",
  "DOMMouseScroll",
  "mouseWheel",
  "mousedown",
  "touchstart",
  "touchmove",
  "MSPointerDown",
  "MSPointerMove",
  "click",
  "mouseover",
  "mouseout",
  "keyup",
  "keypress"
];

class AutoLogout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initializeTime: +new Date(),
      pageX: null,
      pageY: null
    };

    this.tId = null;
  }

  setLastActive = last_active => {
    sessionStorage.setItem(STORE_KEY, last_active.toString());
  };

  getLastActive = () => {
    return parseInt(sessionStorage.getItem(STORE_KEY), 10);
  };

  render() {
    return <div />;
  }

  checkForLocalhost = () => {
    if (window) {
      const { location } = window;
      if (location) {
        const { hostname, port } = location;

        if (
          hostname &&
          hostname.toLowerCase() === "localhost" &&
          port &&
          port + "" === "3000"
        ) {
          return true;
        }
      }
    }

    return false;
  };

  componentWillMount() {
    if (this.checkForLocalhost() === false) {
      this.setLastActive(+new Date());
      EVENTS.forEach(e => document.addEventListener(e, this.handleEvent));
    }
  }

  componentDidMount() {
    if (this.checkForLocalhost() === false) {
      this.reset();
    }
  }

  componentWillUnmount() {
    if (this.checkForLocalhost() === false) {
      clearTimeout(this.tId);
      sessionStorage.removeItem(STORE_KEY);
      EVENTS.forEach(e => document.removeEventListener(e, this.handleEvent));
    }
  }

  handleEvent = e => {
    const { pageX, pageY } = this.state;

    if (e.type === "mousemove") {
      if (e.pageX === pageX && e.pageY === pageY) {
        return;
      }

      if (typeof e.pageX === "undefined" && typeof e.pageY === "undefined") {
        return;
      }

      if (this.getStartDelay() < 200) {
        return;
      }
    }

    clearTimeout(this.tId);

    this.setLastActive(+new Date());

    this.setState({
      pageX: e.pageX,
      pageY: e.pageY
    });

    this.tId = setTimeout(this.logout, LOGOUT_CHECK_INTERVAL);
  };

  logout = () => {
    if (this.getElapsedTime() >= LOGOUT_TIMEOUT) {
      clearTimeout(this.tId);

      if (Auth.isUserAuthenticated()) {
        Auth.deauthenticateUser();
      }

      window.location.href = "/login";

      return;
    }

    clearTimeout(this.tId);
    this.tId = setTimeout(this.logout, LOGOUT_CHECK_INTERVAL);
  };

  reset = () => {
    const { initializeTime } = this.state;

    clearTimeout(this.tId);

    this.setLastActive(initializeTime);

    this.setState({
      initializeTime: +new Date()
    });

    this.tId = setTimeout(this.logout, LOGOUT_CHECK_INTERVAL);
  };

  getElapsedTime = () => {
    return +new Date() - this.getLastActive();
  };

  getStartDelay = () => {
    const { initializeTime } = this.state;

    return +new Date() - initializeTime;
  };
}

export default AutoLogout;



// WEBPACK FOOTER //
// ./src/auth/autologout.js